import { FileInfo } from "@evergis/ui";
import { AttributeDefinitionDc, GeometryType } from "@evergis/api";
import { UpdateAttribute } from "../../../hooks/attributes/useAttributes";
import { FileURLInfo } from "../DialogComponents/FileUploader/types";
import { LayerAttribute } from "../EditResource/components/Layer/LayerAttributeItem";

export interface UploadState {
  uploadInProgress: boolean;
  uploadDone: boolean;
  uploadedFiles: FileInfo[];
  uploadError: string;
  uploadDelete: (name: string) => void;
}

export interface UploadDataContextType {
  step?: UploadFileStep;
  nextText?: string;
  nextStep?: VoidFunction;
  prevStep?: VoidFunction;
  onFileDelete?: (name: string) => void;
  uploadFiles?: (files: File[]) => void;
  uploadDone?: boolean;
  uploadedFiles?: FileInfo[];
  uploadFileURL?: (fileInfo: FileURLInfo) => void;
  uploadError?: string;
  uploadDelete?: (name: string) => void;
  uploadAttributes?: UploadFileAttributes;
  dateOfImage?: Date;
  onSelectAllAttributes?: VoidFunction;
  onChangeAttributeCheckbox?: (name: string) => void;
  onChangeAttributeValue?: (name: string, value: string) => void;
  maxZoomLevel?: number;
  setMaxZoomLevel?: (maxZoomLevel: number) => void;
  sysAttributes?: LayerAttribute[];
  addSysAttributes?: (attributes: LayerAttribute[]) => void;
  deleteSysAttribute?: (id: string) => void;
  updateSysAttribute?: UpdateAttribute<LayerAttribute>;
}

export type UploadAttribute = AttributeDefinitionDc & {
  id?: string;
  name?: string;
  sysAttribute?: boolean;
  geometryType?: GeometryType;
};

export type UploadAttributeProps = UploadAttribute;

export enum UploadFileAttribute {
  Default = "",
  FileName = "%FILENAME%",
  DateOfImage = "%DATEOFIMAGE%",
}

export enum UploadFileStep {
  Files,
  Attributes,
  Tiling,
}

export type UploadFileAttributes = { [key: string]: string };

export type styledHeaderSubTitleProps = {
  layerName: string;
  step: number;
  uploadedFiles: FileInfo[];
  toLayer: string;
  and: string;
};
